import { getToken as firebaseGetToken, isSupported } from 'firebase/messaging';
import { messaging } from '../firebase';

export async function registerAndGetToken(vapidKey) {
  const supported = await isSupported();
  if (!supported) throw new Error('notifications-not-supported');
  if (typeof Notification === 'undefined') throw new Error('notifications-not-supported');
  if (Notification.permission === 'denied') throw new Error('permission-blocked');
  if (Notification.permission === 'default') {
    const p = await Notification.requestPermission();
    if (p !== 'granted') throw new Error('permission-not-granted');
  }

  if (!messaging) {
    console.warn('[FCM] Messaging instance is null. Skipping token retrieval.');
    return null;
  }

  // Explicitly register the SW and pass to getToken.
  // This bypasses Firebase's internal registration which times out after 10s
  // when the browser has an existing SW or the SW loads slowly.
  let swRegistration;
  try {
    swRegistration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
      scope: '/',
    });
    // Wait for SW to become active if it just installed
    if (swRegistration.installing) {
      await new Promise((resolve, reject) => {
        const sw = swRegistration.installing;
        sw.addEventListener('statechange', function handler() {
          if (this.state === 'activated') {
            resolve();
            sw.removeEventListener('statechange', handler);
          }
          if (this.state === 'redundant') {
            reject(new Error('SW became redundant'));
            sw.removeEventListener('statechange', handler);
          }
        });
      });
    }
    console.log('[FCM] ✅ SW registered, scope:', swRegistration.scope);
  } catch (swErr) {
    // Non-fatal: fall back to Firebase auto-registration
    console.warn('[FCM] ⚠️ Explicit SW registration failed, using auto:', swErr.message);
    swRegistration = undefined;
  }

  try {
    const tokenOptions = { vapidKey };
    if (swRegistration) tokenOptions.serviceWorkerRegistration = swRegistration;
    const token = await firebaseGetToken(messaging, tokenOptions);
    console.log('[FCM] ✅ Token obtained:', token ? token.substring(0, 20) + '...' : 'null');
    return token;
  } catch (err) {
    console.error('[FCM] ❌ Token retrieval failed:', err);
    throw err;
  }
}

export default { registerAndGetToken };
